// extracted by mini-css-extract-plugin
export default {"base":"Header_base__eGYad"};